<script>
import { initLanguage } from './i18n/index.js'
import i18nMixin from './mixins/i18nMixin.js';
import { initAuthSync, destroyAuthSync } from './utils/authSync.js'
import { handleError } from './utils/errorHandler.js'

export default {
  mixins: [i18nMixin],
  globalData: {
    isDarkMode: false,
    currentLanguage: 'zh-CN'
  },
  onLaunch: function() {
    // 深色模式已停用，各页面固定使用产品指定主题
    // const savedDarkMode = uni.getStorageSync('isDarkMode')
    // if (savedDarkMode !== '') {
    //   this.globalData.isDarkMode = savedDarkMode
    //   this.applyDarkMode(savedDarkMode)
    // }
    
    const lang = initLanguage()
    this.globalData.currentLanguage = lang
    
    // #ifdef H5
    initAuthSync()
    // #endif
  },
  onShow: function() {
  },
  onHide: function() {
    // #ifdef H5
    try {
      destroyAuthSync()
    } catch (e) {
      handleError(e)
    }
    // #endif
  },
  onError: function(error) {
    // 全局错误捕获
    handleError(error)
  },
  methods: {
    // 深色模式已停用
    // applyDarkMode(isDark) {
    //   const root = document.documentElement
    //   if (isDark) {
    //     root.classList.add('dark-mode')
    //   } else {
    //     root.classList.remove('dark-mode')
    //   }
    // },
    // toggleDarkMode(isDark) {
    //   this.globalData.isDarkMode = isDark
    //   this.applyDarkMode(isDark)
    //   uni.setStorageSync('isDarkMode', isDark)
    // },
    // 多语言已停用，固定简体中文
    // onLanguageChange(lang) {
    //   this.globalData.currentLanguage = lang
    // }
  }
}
</script>

<style>

:root {
  --bg-color: #F1F2F9;
  --panel-bg: #FFFFFF;
  --text-color: #060218;
  --time-text:#706F83;
  --border-color: #E5E5EA;
  --mask-color: rgba(0, 0, 0, 0.5);
  --tag-color :#9F9E9E;
  --search-color: #F1F2F9;;
  --mobile-searchcolor:#E2E4F0;
  --id-bg:#DBDEF1;
  --delete-bg :linear-gradient(to bottom, #F1DBFF 0%, #FFFFFF 30.75%);
  --card--bg :#F1F2F9;
  --heji--bg:#F8FAFA;
  --button-color:#F8FAFA;
  --auther--color:#706F83;
  --comment-divider:#D9D9D9;
  --heji--button:#FFFFFF;
  --comment--color:#FFFFFF;
  --comment--textarea:#F1F2F9;
  --setting--divider:#F1F2F9;
  --post--card:#ffff;
  --pc--profile:#fff;
  --pc--postcardboder:#E2E4F0;
  --pc--item:#F1F2F9;
  --pc--select:#F1F2F9;
  --content-color:#F8F8FA;
  --tag--boder--:#D9DAE0;
  --biaoqian--:#F1F2F9;
  --pc--bottom-bg:#E3E5F3;
  --mulu-text:#706F83;
  --filter-tag:#fbdbe7;
  --pc--boxshdow:rgba(179, 185, 224, 0.19);
  --search-border:#E2E4F0;
  --biaoqianbg--:#f1f2f9;
  --top--divider:#f1f2f9;
  --search-tag:#f1f2f9;
  --text-color-secondary: #706F83;
  --skeleton-base: #f0f0f0;

  /* PC端响应式内容宽度变量 */
  --pc-detail-width: 660px;      /* 详情页宽度（novel, video, short-story） */
  --pc-list-width: 900px;        /* 列表页宽度（profile, purchased等） */
  --pc-narrow-width: 343px;      /* 窄页面宽度（redeem-code等） */
}

/* PC端响应式布局 - 根据屏幕分辨率动态调整内容宽度 */
@media screen and (min-width: 1024px) {
  /* 基础宽度 */
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 900px;
    --pc-narrow-width: 343px;
  }
}

@media screen and (min-width: 1280px) {
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 1000px;
    --pc-narrow-width: 400px;
  }
}

@media screen and (min-width: 1440px) {
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 1100px;
    --pc-narrow-width: 450px;
  }
}

@media screen and (min-width: 1680px) {
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 1200px;
    --pc-narrow-width: 500px;
  }
}

@media screen and (min-width: 1920px) {
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 1300px;
    --pc-narrow-width: 550px;
  }
}

@media screen and (min-width: 2560px) {
  /* 2K 分辨率 */
  :root {
    --pc-detail-width: 660px;
    --pc-list-width: 1500px;
    --pc-narrow-width: 650px;
  }
}

/* ===== 首页 / Feed / 活动 三页统一版心（市场主流：居中 max-width + 固定 gutter）=====
   单一数据源：三页 wrapper 只消费这两个变量，内部列一律 100% 填充，
   避免各页手写宽度 + !important 补丁导致的漂移与跳动 */
:root {
  --home-gutter: 25px;   /* 版心左右留白（还原原 feed 25px） */
  --home-max: 950px;     /* 默认版心 → 内容列 950 */
}
@media screen and (min-width: 1200px) {
  :root { --home-max: 1100px; }  /* 内容列 1050 */
}
@media screen and (min-width: 1920px) {
  :root { --home-max: 1300px; }  /* 内容列 1250 */
}

:root.dark-mode {
  --bg-color: #000;
  --panel-bg: #181818;
  --text-color: rgba(240, 240, 242, 0.85);
  --time-text:rgba(240, 240, 242, 0.85);
  --border-color: #2B2C31;
  --mask-color: rgba(0, 0, 0, 0.8);
  --tag-color :#424242;
  --search-color: #2B2C31;
  --id-bg:#2B2C31;
  --delete-bg:#2B2C31;
  --card--bg :#181818;
  --heji--bg:#2B2C31;
  --heji--button:#3B3C42;
  --button-color:#2B2C31;
  --auther--color:#F0F0F2;
  --comment-divider:#333337;
  --comment--color:#2B2C31;
  --comment--textarea:#3C3D44;
  --setting--divider:#000;
  --post--card:#000;
  --pc--profile:#181818;
  --pc--postcardboder:#333337;
  --pc--item:#2B2C31;
  --pc--select:#3B3C42;
  --content-color:#181818;
  --tag--boder--:#404146;
  --biaoqian--:#434445;
  --pc--bottom-bg:#181818;
  --pc--boxshdow:rgba(0, 0, 0, 0.50);
  --mulu-text:#706F83;
  --filter-tag:rgba(234, 76, 137, 0.30);
  --search-border:#181818;
  --biaoqianbg--:#303032;
  --top--divider:#28282B;
  --search-tag:#45454B;
  --mobile-searchcolor:#2B2C31;
  --text-color-secondary: rgba(240, 240, 242, 0.6);
  --skeleton-base: #2a2a2a;
}

/* 预留滚动条位置，避免滚动条出现/消失（如加载态→真实内容）引起内容横向跳动。
   视口滚动条的 gutter 由根元素传播，故 html 与 body 同时声明，兼容不同滚动容器 */
html {
  scrollbar-gutter: stable;
}

body {
  background-color: var(--bg-color);
  color: var(--text-color);
  margin: 0;
  padding: 0;
  overscroll-behavior: none;
  scrollbar-gutter: stable;
}

/* #ifdef H5 */
.uni-toast,
.uni-showToast,
uni-toast,
uni-toast .uni-toast,
uni-toast .uni-showToast {
  z-index: 2147483647 !important;
}

.uni-toast__mask,
.uni-showToast__mask,
uni-toast .uni-toast__mask,
uni-toast .uni-showToast__mask {
  z-index: 2147483646 !important;
}

/* H5 端 uni-scroll-view 与 .uni-scroll-view 统一暗色半透明滚动条支持 */
uni-scroll-view,
.uni-scroll-view,
uni-scroll-view-content,
.uni-scroll-view-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
}

uni-scroll-view::-webkit-scrollbar,
.uni-scroll-view::-webkit-scrollbar,
uni-scroll-view-content::-webkit-scrollbar,
.uni-scroll-view-content::-webkit-scrollbar,
uni-scroll-view *::-webkit-scrollbar,
.uni-scroll-view *::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

uni-scroll-view::-webkit-scrollbar-track,
.uni-scroll-view::-webkit-scrollbar-track,
uni-scroll-view-content::-webkit-scrollbar-track,
.uni-scroll-view-content::-webkit-scrollbar-track,
uni-scroll-view *::-webkit-scrollbar-track,
.uni-scroll-view *::-webkit-scrollbar-track {
  background: transparent !important;
}

uni-scroll-view::-webkit-scrollbar-thumb,
.uni-scroll-view::-webkit-scrollbar-thumb,
uni-scroll-view-content::-webkit-scrollbar-thumb,
.uni-scroll-view-content::-webkit-scrollbar-thumb,
uni-scroll-view *::-webkit-scrollbar-thumb,
.uni-scroll-view *::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4) !important;
  border-radius: 3px !important;
  transition: background 0.2s ease !important;
}

uni-scroll-view::-webkit-scrollbar-thumb:hover,
.uni-scroll-view::-webkit-scrollbar-thumb:hover,
uni-scroll-view-content::-webkit-scrollbar-thumb:hover,
.uni-scroll-view-content::-webkit-scrollbar-thumb:hover,
uni-scroll-view *::-webkit-scrollbar-thumb:hover,
.uni-scroll-view *::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6) !important;
}

uni-scroll-view::-webkit-scrollbar-thumb:active,
.uni-scroll-view::-webkit-scrollbar-thumb:active,
uni-scroll-view-content::-webkit-scrollbar-thumb:active,
.uni-scroll-view-content::-webkit-scrollbar-thumb:active,
uni-scroll-view *::-webkit-scrollbar-thumb:active,
.uni-scroll-view *::-webkit-scrollbar-thumb:active {
  background: #EA4C89 !important;
}
/* 保证轮播图与 uni-swiper 手动左右滑动顺畅 */
swiper, uni-swiper, .uni-swiper-wrapper, .swiper-item, uni-swiper-item {
  touch-action: pan-x pan-y !important;
  pointer-events: auto !important;
}
/* #endif */
</style>